// Simple mark representing Oma's presence

import { motion } from 'framer-motion';
import type { CapacityLevel } from '../types';

interface OmaMarkProps {
  capacity: CapacityLevel;
}

const capacityColors: Record<CapacityLevel, string> = {
  deep: 'var(--color-capacity-deep)',
  sustained: 'var(--color-capacity-sustained)',
  limited: 'var(--color-capacity-limited)',
  minimal: 'var(--color-capacity-minimal)',
};

export function OmaMark({ capacity }: OmaMarkProps) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 'var(--space-3xl) 0'
    }}>
      <motion.div
        initial={{ opacity: 0.6 }}
        animate={{ 
          opacity: [0.6, 0.8, 0.6],
          backgroundColor: capacityColors[capacity]
        }}
        transition={{
          opacity: {
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut"
          },
          backgroundColor: {
            duration: 0.5,
            ease: "easeInOut"
          }
        }}
        style={{
          width: '2px',
          height: '24px',
          backgroundColor: capacityColors[capacity]
        }}
      />
    </div>
  );
}
